import { createFileRoute, Link } from "@tanstack/react-router";
import { CourseShell } from "@/components/CourseShell";
import { PublicIntroVideo } from "@/components/PublicIntroVideo";

const mono = { fontFamily: '"JetBrains Mono", monospace' } as const;
const serif = { fontFamily: '"Cormorant Garamond", serif' } as const;

export const Route = createFileRoute(
  "/courses/business-and-accountancy/basic-business-accountancy_/lessons/intro",
)({
  head: () => {
    const title = "Course intro — The Basic Business Accountancy Course — WHO KNEW";
    const description =
      "A two-minute introduction to The Basic Business Accountancy Course. What it is, who it's for, and how it works.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
      ],
    };
  },
  component: IntroLessonPage,
});

function IntroLessonPage() {
  return (
    <CourseShell activeLessonId={null}>
      <div style={{ paddingBottom: "96px" }}>
        <PublicIntroVideo
          playbackId="OH02wn9XeVCHm02HFjNDqD9wsSa4utftwDHX463cik01vg"
          eyebrow="Course intro"
          title="What this is."
          duration="2 minutes 20 seconds"
        />

        <div style={{ marginTop: "48px", maxWidth: "720px" }}>
          <hr className="border-0 h-px bg-burgundy" />
          <p
            className="font-bold uppercase tracking-[0.05em] text-burgundy"
            style={{ ...mono, fontSize: "11px", marginTop: "16px" }}
          >
            Up next
          </p>
          <h3
            className="text-ink"
            style={{ ...serif, fontSize: "22px", fontWeight: 700, marginTop: "8px", lineHeight: 1.3 }}
          >
            <Link
              to="/courses/business-and-accountancy/basic-business-accountancy/lessons/$lessonId"
              params={{ lessonId: "1.1" }}
              className="link-hit transition-colors hover:text-burgundy"
            >
              Lesson 1.1 - What a P&amp;L actually is
            </Link>
          </h3>
        </div>
      </div>
    </CourseShell>
  );
}
